<template>
  <div class="be-content">
    <div class="main-content container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="panel panel-default">
            <div class="panel-heading">
              <h3>Обращения в службу технической поддержки</h3>
              <router-link :to="{name: 'ticket-add'}">
                <button class="btn btn-success btn-lg pull-right" style="margin-bottom: 10px">
                  <i class="icon icon-left mdi mdi-plus-square"></i>
                  Создать новое обращение
                </button>
              </router-link>
              <p>Обращаем Ваше внимание, что раздел поддержки предназначен для консультирования по техническим вопросам и не предназначен для общих вопросов по курортному сбору.</p>
            </div>
            <div class="panel-body">
              <table class="table table-condensed table-hover table-bordered table-striped"
                     v-if="tickets && tickets.length>0">
                <thead>
                <tr>
                  <th style="width: 2%" class="number">#</th>
                  <th style="width: 15%">Дата обращения</th>
                  <th>Тема</th>
                  <th v-if="$auth.user().is_superuser">Пользователь </th>
                  <th style="width: 8%">Статус</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(ticket, index) in tickets">
                  <td class="number">{{ index + 1 }}</td>
                  <td>{{ticket.created_at | dateFilter("DD.MM.YYYY") }}г.<br> {{ticket.created_at | dateFilter("HH:mm") }}</td>
                  <td>
                    <router-link
                      :to="{name:'ticket-comments', params: {ticketId: ticket.id}}">
                      {{ticket.subject }}
                    </router-link>
                  </td>
                  <th v-if="$auth.user().is_superuser">{{ticket.created_by}}</th>
                  <td>{{getTicketStatus(ticket.status)}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'

  export default {
    data: function () {
      return {
        tickets: null,
      }
    },
    created () {
      this.getTickets()
    },
    methods: {
      getTickets () {
        let self = this
        axios.get('/api/tickets/').then(function (response) {
          self.tickets = response.data
        }).catch(function (error) {
        })
      },
      getTicketStatus (status) {
        if (status === 'New') {
          return 'Новое'
        } else if (status === 'In progress') {
          return 'В работе'
        } else if (status === 'Solved') {
          return 'Обработано (решено)'
        } else if (status === 'In progress') {
          return 'Закрыто'
        }
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/support/TicketList.vue